module.exports = __webpack_public_path__ + "static/media/card-discover.1bb3f60a.svg";